export enum LedType {
    Holding = 'Holding',
    Error = 'Error',
    Idle = 'Idle'
}